export default "__VITE_ASSET__DDybO9Ay__"